import { render } from "./youtube_pop_up.vue?vue&type=template&id=25ada224"
import script from "./youtube_pop_up.vue?vue&type=script&lang=js"
export * from "./youtube_pop_up.vue?vue&type=script&lang=js"

import "./youtube_pop_up.vue?vue&type=style&index=0&id=25ada224&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__